import {ChangeDetectionStrategy, Component, inject, Input, OnInit, ViewChild, OnDestroy,} from '@angular/core';
import {FileService, ListTable, NgxEasyTablePagination, ProductCustomer} from 'compob2b-libs';
import {SearchAutocompleteComponent} from '../../search-autocomplete/search-autocomplete.component';
import {ModalProductComponent} from '../modal-product/modal-product.component';
import {ProductService} from '../services/product.service';
import {DatePipe, NgClass, NgForOf, NgIf, NgStyle} from '@angular/common';
import {NgxPaginationModule} from 'ngx-pagination'
import {BaseModule} from '../../../../../../compob2b-table/lib/components/base/base.module'
import {AddToCartComponent} from '../../cart/add-to-cart/add-to-cart.component'
import {ProductPriceComponent} from '../product-list/product-price/product-price.component'
import {AddToRequestedProductsPopupComponent} from '../add-to-requested-products-popup/add-to-requested-products-popup.component'
import {NbButtonModule, NbIconModule} from '@nebular/theme'
import {SearchCodeHighlightComponent} from '../../search-code-highlight/search-code-highlight.component';
import {UtilsService} from '../../utils/utils.service'
import { DeviceService } from "../../../../../../compob2b-libs/src/lib/services/device.service";

@Component({
  selector: 'app-customer-product-table',
  templateUrl: './product-table.component.html',
  styleUrls: ['product-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SearchCodeHighlightComponent,
    NgStyle,
    NgxPaginationModule,
    BaseModule,
    AddToCartComponent,
    ProductPriceComponent,
    NbButtonModule,
    NbIconModule,
    NgClass,
    DatePipe,
    NgForOf,
    NgIf
  ]
})
export class ProductTableComponent extends ListTable implements OnInit, OnDestroy {

  @Input() searchKeyword: string | null = '';
  @Input() productList: ProductCustomer[];
  @Input() pagination: NgxEasyTablePagination;
  @Input() showOnlySupplerWarehouse = false;
  @ViewChild(SearchAutocompleteComponent) autocomplete: SearchAutocompleteComponent;
  isShowcase: boolean = false;
  isShowFilter: boolean = false;
  productService = inject(ProductService);
  fileService = inject(FileService);
  device =  inject(DeviceService);


  ngOnInit() {
    this.isShowcase = UtilsService.isCurrentDomainShowcase();
    this.updateFilterState()
    window.addEventListener('filterToggle', this.handleFilterToggle.bind(this));

  }

  ngOnDestroy() {
    window.removeEventListener('filterToggle', this.handleFilterToggle.bind(this));
    super.ngOnDestroy();
  }

  private handleFilterToggle(event: any) {
    this.isShowFilter = event.detail;
    this.cdr.detectChanges();
  }

  getImageUri(picture: string) {
    return picture && picture !== '.' ? this.fileService.getImageSrc(picture, 800) : this.noPhotoSrc;
  }

  openAddToRequestedProducts(product: ProductCustomer): void {
    this.windowService.open(AddToRequestedProductsPopupComponent, {
      context: {
        product,
        amount: 1
      }
    });
  }

  private updateFilterState() {
    const filterValue = localStorage.getItem('isShowFilter');
    this.isShowFilter = !!(filterValue && filterValue !== '0' && filterValue !== 'false');
    this.cdr.detectChanges();
  }

  openModalProduct(product: ProductCustomer): void {
    const uid = product.sync === false ? product.syncUidPim : product.syncUid;
    if (!product) return
    if (this.device.isMobile) {
      this.router.navigate(['/product/', uid]);
    } else {
      this.productService.openModalProduct(ModalProductComponent, uid, this.productList);
    }
  }

  isShowRequestedProducts(product: ProductCustomer) : boolean {
    return this.productService.isShowRequestedProducts(product);
  }
}
